// Fecha límite global de la oferta de lanzamiento (igual para todas las usuarias).
export const OFFER_DEADLINE = new Date(2026, 8, 16, 23, 59, 59)

const MONTHS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'setiembre',
  'octubre',
  'noviembre',
  'diciembre',
]

export function formatOfferDeadline(): string {
  return `${OFFER_DEADLINE.getDate()} de ${MONTHS[OFFER_DEADLINE.getMonth()]}`
}
